// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"09a61bea","749":"2f0730fc","906":"5e1a6a63"}[chunkId] + ".chunk.js";
};